import React from 'react';
import { CircleMarker, Tooltip } from 'react-leaflet';
import { indego_stations } from '../data/indego_stations';

export const IndegoStations = () => {

  function onEachFeature(feature, layer) {
    layer.bindPopup(feature.properties.name);
  }

  function getFeatureStyle(feature) {
    return {
      color: '#0078a8',
      fillColor: '#0078a8',
      fillOpacity: 0.8,
      radius: 3,
      weight: 1,
    };
  }

  return (
    <>
      {indego_stations.features.map(feature => (
        <CircleMarker
          key={feature.properties.kioskId}
          center={[feature.geometry.coordinates[1], feature.geometry.coordinates[0]]}
          onEachFeature={onEachFeature}
          radius={getFeatureStyle(feature).radius}
          fillOpacity={getFeatureStyle(feature).fillOpacity}
          stroke={false}
          fillColor={getFeatureStyle(feature).fillColor}
        >
          <Tooltip direction="top">
            Kiosk Id: {feature.properties.station}
            <br />
            Name: {feature.properties.name}
            <br />
            Ridership(week): {feature.properties.ridership_week}
            <br />
            Built year: {feature.properties.go_live_year}

          </Tooltip>
        </CircleMarker>
      ))}
    </>
  );
}
